module.exports = __webpack_public_path__ + "img/bd7d2db.jpg";